import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "workinghours"

function* loadWorkingHours(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadWorkingHours.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadWorkingHours.failure(getErrorMsg(error)));
  }
}

function* showWorkingHour(action) {
  try {
    const { id, user_id, token } = action.payload;
    const res = yield fetcher.post(`${url}/${id}`, { id, user_id }, token);
    yield put(actions.showWorkingHour.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showWorkingHour.failure(getErrorMsg(error)));
  }
}

function* createWorkingHour(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createWorkingHour.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createWorkingHour.failure(getErrorMsg(error)));
  }
}

function* updateWorkingHour(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateWorkingHour.success(res.data));
   
  } catch (error) {
    handleError(error);
    yield put(actions.updateWorkingHour.failure(getErrorMsg(error)));
  }
}

function* deleteWorkingHour(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteWorkingHour.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteWorkingHour.failure(getErrorMsg(error)));
  }
}

export default function* watchDistance() {
  yield all([
    takeEvery(actions.LOAD_WORKING_HOUR.REQUEST, loadWorkingHours),
    takeEvery(actions.SHOW_WORKING_HOUR.REQUEST, showWorkingHour),
    takeEvery(actions.CREATE_WORKING_HOUR.REQUEST, createWorkingHour),
    takeEvery(actions.UPDATE_WORKING_HOUR.REQUEST, updateWorkingHour),
    takeEvery(actions.DELETE_WORKING_HOUR.REQUEST, deleteWorkingHour),
  ]);
}
